import ForgotComponent from './forgot.vue'
export default ForgotComponent
